export default function ObjectPDF(props) {
 
  return (
    
      <object {...props}
      data={`${props.data}
      ${props.toolbar?'':'#toolbar=0'}
      `}
      >{props.children}</object>
    
  )
}
